import { NgTemplateOutlet } from "@angular/common";
import { Component, contentChild, TemplateRef } from "@angular/core";
import { Card } from "primeng/card";

@Component({
  selector: "new-ui-dashboard-card",
  templateUrl: "./new-ui-dashboard-card.component.html",
  imports: [Card, NgTemplateOutlet],
})
export class NewUiDashboardCardComponent {
  protected readonly header = contentChild<TemplateRef<void>>("header");
}
